import { useCallback, useContext, useEffect, useState } from "react";
import CustomInput from "../../../components/CustomInput";
import ToggleSwitch from "../../../components/ToggleSwitch";
import CustomSelect from "../../../components/CustomSelect";
import { getAvatarSrc } from "../../../../../utils/GetImageSrc";
import { categoryService } from "../../../../../services/api/categoryService";
import { proceduceService } from "../../../../../services/api/procedureService";
import { AuthContext } from "../../../../../contexts/AuthContext";
import { toast } from "react-toastify";

const TabInfo = ({ data, onInputChange }) => {
  const { token } = useContext(AuthContext);
  const [dataCategory, setDataCategory] = useState([]);
  const [dataProcedure, setDataProcedure] = useState([]);
  const form_options = [
    { value: "dang_ky_nhan_hieu", label: "Đăng ký nhãn hiệu" },
    {
      value: "dang_ky_kieu_dang_cong_nghiep",
      label: "Đăng ký kiểu dáng công nghiệp",
    },
    {
      value: "dang_ky_sang_che_giai_phap_huu_ich",
      label: "Đăng ký sáng chế giải pháp hữu ích",
    },
    { value: "dang_ky_gia_han", label: "Đăng ký gia hạn" },
    {
      value: "dang_ky_sua_doi_don_van_bang",
      label: "Đăng ký sửa đổi đơn/ văn bằng",
    },
    {
      value: "chuyen_giao_chuyen_nhuong_don_van_bang",
      label: "Chuyển giao, chuyển nhượng đơn/văn bằng",
    },
    { value: "tra_cuu_thong_tin", label: "Tra cứu thông tin" },
    { value: "dang_ky_ban_quyen", label: "Đăng ký bản quyền" },
    { value: "dich_vu_khac", label: "Dịch vụ khác" },
  ];
  const handleToggle = () => {
    const newStatus =
      data.status === "Đang hoạt động" ? "Không hoạt động" : "Đang hoạt động";
    onInputChange("status", newStatus);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!["image/jpeg", "image/png"].includes(file.type)) {
      toast.error("Chỉ chấp nhận định dạng JPEG/PNG.");
      return;
    }

    if (file.size > 25 * 1024 * 1024) {
      toast.error("Kích thước tệp vượt quá 25MB.");
      return;
    }
    if (file) {
      onInputChange("image", file);
    }
  };

  const fetchListCategoryService = useCallback(async () => {
    try {
      const response = await categoryService.get("", token);
      if (response) {
        const dataConvert = response.categories.map((item) => ({
          value: item.name,
          label: item.name,
        }));
        setDataCategory(dataConvert);
      }
    } catch (error) {
      toast.dismiss();
      console.error("Error fetching categories:", error);
    }
  }, [token]);

  const fetchListProcedure = useCallback(async () => {
    try {
      const response = await proceduceService.get_all("", token);
      if (response) {
        const dataConvert = response.data.procedures.map((item) => ({
          value: item._id,
          label: item.name,
        }));
        setDataProcedure(dataConvert);
      }
    } catch (error) {
      toast.dismiss();
      console.error("Error fetching procedures:", error);
    }
  }, [token]);

  useEffect(() => {
    fetchListCategoryService();
    fetchListProcedure();
  }, [fetchListCategoryService, fetchListProcedure]);

  return (
    <div className="mt-6">
      {/* Image Upload */}
      <div className="mb-6 flex items-center">
        <label
          htmlFor="image-upload"
          className="cursor-pointer w-28 h-28 bg-gray-100 flex items-center justify-center rounded-md overflow-hidden relative hover:opacity-75"
        >
          {data.image ? (
            <img
              src={data.image?.url || getAvatarSrc(data.image)}
              alt="Uploaded"
              className="w-full h-full object-contain"
            />
          ) : (
            <div className="flex items-center justify-center text-gray-400">
              <img src="/icons/camera-icon.svg" alt="Camera icon" />
            </div>
          )}
          <input
            id="image-upload"
            type="file"
            accept="image/*"
            className="hidden"
            onChange={handleImageChange}
          />
        </label>
      </div>

      {/* Form Fields */}
      <div className="grid grid-cols-2 gap-4">
        <CustomInput
          placeholder="Mã dịch vụ"
          required={true}
          value={data.serviceCode}
          onChange={(value) => onInputChange("serviceCode", value)}
        />
        <CustomSelect
          options={dataCategory || []}
          placeholder="Loại dịch vụ"
          required={true}
          value={data.category}
          onChange={(option) => onInputChange("category", option)}
        />
        <CustomInput
          placeholder="Tên dịch vụ"
          required={true}
          value={data.serviceName}
          onChange={(value) => onInputChange("serviceName", value)}
        />

        <CustomSelect
          options={form_options}
          placeholder="Chọn loại form"
          required={true}
          value={data.formName}
          onChange={(option) => onInputChange("formName", option)}
        />
        <CustomSelect
          options={dataProcedure || []}
          placeholder="Chọn thủ tục hướng dẫn"
          required={true}
          value={data.procedure_id}
          onChange={(option) => onInputChange("procedure_id", option)}
        />
        <CustomInput
          placeholder="Thứ tự ưu tiên"
          type="number"
          value={data.priority}
          onChange={(value) => onInputChange("priority", value)}
        />
        <div className="space-y-2">
          <label className="block font-sf-medium text-gray-700">
            Thời gian nộp đơn
          </label>
          <CustomInput
            placeholder="Ví dụ: 1-3 ngày"
            value={data.submissionTime}
            onChange={(value) => onInputChange("submissionTime", value)}
          />
        </div>
        <div className="space-y-2">
          <label className="block font-sf-medium text-gray-700">
            Thời gian thẩm định
          </label>
          <CustomInput
            placeholder="Ví dụ: 8-10 tháng"
            value={data.reviewTime}
            onChange={(value) => onInputChange("reviewTime", value)}
          />
        </div>
      </div>
      <div className="flex items-center mt-4">
        <span className="mr-4 text-[#0267FF] font-sf-medium w-[120px]">
          {data.status}
        </span>
        <ToggleSwitch
          enabled={data.status === "Đang hoạt động"}
          onToggle={handleToggle}
        />
      </div>
    </div>
  );
};

export default TabInfo;
